import { OnlineStorage } from "@tblabs/storage";
import { RefString, TextInput, Snack } from "@tblabs/truffle";
import { Panel } from "../Components/Panel";
import { PrimaryButton } from "../Components/PrimaryButton";
import { Page } from "./Page";


export class AddDatabasePage extends Page
{
    constructor(private _storage: OnlineStorage)
    {
        super("Database creation");

        this.Content(async () =>
        {
            const databaseDir = new RefString();
          
            this.body.Append(
                new Panel("New Database", [
                    new TextInput(databaseDir).Placeholder("Database name (not a directory)"),
                    new PrimaryButton("Create").OnClick(() => this.CreateDatabase(databaseDir)).MarginTop(12),
                ]),
                new Panel("Users", [
                    "Admin and Anonymous user will be automatically created. Default login for Admin is 'admin' with password 'admin'.",
                ])
            );
        });
    }

    private async CreateDatabase(databaseDir: RefString): Promise<void>
    {
        try
        {
            await this._storage.CreateDatabase(databaseDir.value);

            new Snack("✅ Database created");

            window.location.hash = `admin/databases`;
        }
        catch (ex: any)
        {
            new Snack("❌ Failed to create database", ex.message);
        }
    }
}
